module.exports = __webpack_public_path__ + "images/5554ba2151db0cb0d7688ebdd3765eee4770b39f9390e953e3a8bd469dfe7427.svg";